export default __webpack_public_path__ + "47d9ca1a24840e9456fabff8548a1dfc.svg";